module.exports = __webpack_public_path__ + "img/dice-1.26969508.svg";